function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/editableelement
 */
import ContainerElement from './containerelement';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
/**
 * Editable element which can be a {@link module:engine/view/rooteditableelement~RootEditableElement root}
 * or nested editable area in the editor.
 *
 * Editable is automatically read-only when its {@link module:engine/view/document~Document Document} is read-only.
 *
 * The constructor of this class shouldn't be used directly. To create new `EditableElement` use the
 * {@link module:engine/view/downcastwriter~DowncastWriter#createEditableElement `downcastWriter#createEditableElement()`} method.
 *
 * @extends module:engine/view/containerelement~ContainerElement
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var EditableElement = /*#__PURE__*/function (_ContainerElement) {
  _inherits(EditableElement, _ContainerElement);

  var _super = _createSuper(EditableElement);

  /**
   * Creates an editable element.
   *
   * @see module:engine/view/downcastwriter~DowncastWriter#createEditableElement
   * @protected
   */
  function EditableElement(document, name, attrs, children) {
    var _this;

    _classCallCheck(this, EditableElement);

    _this = _super.call(this, document, name, attrs, children);
    /**
     * Whether the editable is in read-write or read-only mode.
     *
     * @observable
     * @member {Boolean} module:engine/view/editableelement~EditableElement#isReadOnly
     */

    _this.set('isReadOnly', false);
    /**
     * Whether the editable is focused.
     *
     * This property updates when {@link module:engine/view/document~Document#isFocused document.isFocused} or view
     * selection is changed.
     *
     * @readonly
     * @observable
     * @member {Boolean} module:engine/view/editableelement~EditableElement#isFocused
     */


    _this.set('isFocused', false);

    _this.bind('isReadOnly').to(document);

    _this.bind('isFocused').to(document, 'isFocused', function (isFocused) {
      return isFocused && document.selection.editableElement == _assertThisInitialized(_this);
    }); // Update focus state based on selection changes.


    _this.listenTo(document.selection, 'change', function () {
      _this.isFocused = document.isFocused && document.selection.editableElement == _assertThisInitialized(_this);
    });

    return _this;
  }
  /**
   * Checks whether this object is of the given.
   *
   *		editableElement.is( 'editableElement' ); // -> true
   *		editableElement.is( 'element' ); // -> true
   *		editableElement.is( 'node' ); // -> true
   *		editableElement.is( 'view:editableElement' ); // -> true
   *		editableElement.is( 'view:element' ); // -> true
   *		editableElement.is( 'view:node' ); // -> true
   *
   *		editableElement.is( 'model:element' ); // -> false
   *		editableElement.is( 'documentFragment' ); // -> false
   *
   * Assuming that the object being checked is an editbale element, you can also check its
   * {@link module:engine/view/editableelement~EditableElement#name name}:
   *
   *		editableElement.is( 'element', 'div' ); // -> true if this is a div element
   *		editableElement.is( 'editableElement', 'div' ); // -> same as above
   *		text.is( 'element', 'div' ); -> false
   *
   * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
   *
   * @param {String} type Type to check.
   * @param {String} [name] Element name.
   * @returns {Boolean}
   */


  _createClass(EditableElement, [{
    key: "is",
    value: function is(type) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!name) {
        return type === 'editableElement' || type === 'view:editableElement' || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
        type === 'containerElement' || type === 'view:containerElement' || type === 'element' || type === 'view:element' || type === 'node' || type === 'view:node';
      } else {
        return name === this.name && (type === 'editableElement' || type === 'view:editableElement' || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
        type === 'containerElement' || type === 'view:containerElement' || type === 'element' || type === 'view:element');
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
  }]);

  return EditableElement;
}(ContainerElement);

export { EditableElement as default };
mix(EditableElement, ObservableMixin);